var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowtieAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9 9.44772 9.44772 9 10 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H10C9.44772 15 9 14.5523 9 14V10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0895 15.373C16.349 14.979 16.5 14.5071 16.5 14V10C16.5 9.49283 16.349 9.02094 16.0895 8.62683L19.1877 7.24982C20.5103 6.66201 22 7.63013 22 9.07745V14.9224C22 16.3697 20.5103 17.3378 19.1877 16.75L16.0895 15.373Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91047 15.373C7.65099 14.979 7.5 14.5071 7.5 14V10C7.5 9.49283 7.65102 9.02094 7.91055 8.62683L4.81228 7.24982C3.4897 6.66201 2 7.63013 2 9.07745V14.9224C2 16.3697 3.4897 17.3378 4.81228 16.75L7.91047 15.373Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowtieAlt);
export default __webpack_public_path__ + "static/media/bowtie-alt.5474ef5fdf6a357bb315f4f7e6553c3e.svg";
export { ForwardRef as ReactComponent };